import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TravelWithPetsComponent } from './travel-with-pets.component';
import { TooltipDirectiveModule } from '@lib/directives';
import { StaticMsgModule } from '@lib/pipes';
import { TableSliderModule } from '@common/components/feature-part/table-slider/table-slider.module';

@NgModule({
  declarations: [TravelWithPetsComponent],
  imports: [CommonModule, StaticMsgModule, TableSliderModule, TooltipDirectiveModule],
  exports: [TravelWithPetsComponent],
})
export class TravelWithPetsModule {}
